import { ReactComponent as TextLogo } from "ressources/icons/textLogo.svg";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { Dropdown } from "rsuite";

import "./style.css";

export default function Navbar({ activeLink }) {
    const { t, i18n } = useTranslation();
    return (
        <div className="landing-navbar">
            <Link to="/" className="landing-navbar-logo" aria-label={t("credits-home")}>
                <TextLogo className="landing-navbar-logo-svg" aria-hidden="true" />
            </Link>
            <div className="landing-navbar-links" />
            <Dropdown
                className="change-language-dropdown"
                title={i18n.language === "fr" ? "FR" : "EN"}
            >
                <Dropdown.Item
                    active={i18n.language === "fr"}
                    onSelect={() => {
                        i18n.changeLanguage("fr");
                        localStorage.setItem("language", "fr");
                    }}
                >
                    FR
                </Dropdown.Item>
                <Dropdown.Item
                    active={i18n.language === "en"}
                    onSelect={() => {
                        i18n.changeLanguage("en");
                        localStorage.setItem("language", "en");
                    }}
                >
                    EN
                </Dropdown.Item>
            </Dropdown>
        </div>
    );
}
